// -----------------------------------------------------------------------------
// Scripts for hero slider
// -----------------------------------------------------------------------------

$(function () {
  let vh = window.innerHeight * 0.01;
  
  document.documentElement.style.setProperty("--vh", vh + "px");
});